import Vue from 'vue'

const tab = {
  state: {
    activeTab: '',
    tabs: [],
    pathBox: [], //储存path的数组
    closeObj:{},
    homeFetch: false
  },
  mutations: {
    ADD_TAB: (state, tab) => {
      state.tabs.push(tab)
      // state.pathBox.push(tab.path)
    },

    UPDATE_TAB: (state, tab) => {
      state.tabs.splice(state.tabs.findIndex(o => o.path === tab.path), 1, tab)
    },

    SET_TABS: (state, tabs) => {
      state.tabs = tabs
    },

    REMOVE_TAB: (state, path) => {
      state.tabs.splice(state.tabs.findIndex(o => o.path === path), 1)
    },
    REMOVE_ALL_TAB:(state, path)=>{
      state.tabs.splice(1,state.tabs.length-1);
      // console.log(state.tabs)
    },

    ACTIVE_TAB: (state, path) => {
      state.activeTab = path
    },

    SET_PATHBOX: (state) => {
      let arr = []
      for(let tab in state.tabs) {
        arr.push(state.tabs[tab].path)
      }
      state.pathBox = arr
    },

    SET_CLOSE_OBJ: (state,obj) => {
      state.closeObj = obj
    },

    UPDATE_HOME_FETCH: (state,bol) => {
      state.homeFetch = bol
    }
  },
  actions: {
    OpenTab({commit, state}, tab) {
      return new Promise((resolve) => {
        if (state.tabs.some(o => o.path === tab.path)) {
          // 缓存中存在
          commit('UPDATE_TAB', tab)
           resolve(false)
        } else {
          commit('ADD_TAB', tab)
          resolve(true)
        }
        commit('SET_PATHBOX')
        Vue.ss.set('tabs', state.tabs, 10800 * 1000)
        commit('ACTIVE_TAB', tab.path)
      })
    },

    UpdateTab({commit}, tab) {
      commit('UPDATE_TAB', tab)
    },

    InitTabs({commit}, tabs) {
      commit('SET_TABS', tabs)
    },

    CloseTab({commit, state}, path) {
      commit('REMOVE_TAB', path)
      
      Vue.ss.set('tabs', state.tabs, 10800 * 1000)
      if (state.activeTab === path) {
        // 关闭当前页面，切换到上一个页签
        let lastPath = state.pathBox.indexOf(path) - 1
        console.log(lastPath);
        console.log(state.tabs[lastPath].path);
        commit('ACTIVE_TAB', state.tabs[lastPath].path)

      }
      commit('SET_PATHBOX')
    },
    closeAllTab({commit,state}){
      commit('REMOVE_ALL_TAB',state.tabs);
      Vue.ss.set('tabs', state.tabs, 10800 * 1000);
      commit('ACTIVE_TAB', state.tabs[0].path)
    },

    ActiveTab({commit}, path) {
      commit('ACTIVE_TAB', path)
    },

    SetCloseObj({commit}, obj) {
      commit('SET_CLOSE_OBJ', obj)
    },

    HomeFetch({commit,state},bol) {
      return new Promise((resolve) => {
        commit('UPDATE_HOME_FETCH',bol)
        resolve(state.homeFetch)
      })
      
    }
  }
}

export default tab